import React, { Component } from 'react';
import './file-picker.css';
import { AppCollapsible } from '../AppCollapsible';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { previewImage } from '../../../utils/common';
import { AppInputWrapper } from '../AppInputWrapper';

class FilePicker extends Component {

    state = {
        label: this.props.initialValues.label || 'Upload media',
        required: this.props.initialValues.isRequired || false,
        multiple: this.props.initialValues.multiple ? 'Yes' : 'No',
        selectedFiles: [],
        requiredError: this.props.initialValues.isRequired || false,
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            label: this.state.label,
            isRequired: this.state.required,
            multiple: this.state.multiple === 'Yes',
            _value: this.state.selectedFiles.map(el => el.file),
            _hasValidationErrors: this.state.requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value })
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked })
    };

    setMultipleState = (e) => {
        this.setState({ multiple: e.target.value });
    };

    handlePickerChange = (event) => {
        const files = []

        if (this.state.multiple === 'No' && this.state.selectedFiles.length >= 1) {
            alert("You can upload only one file");
            return;
        }

        for (const file of event.target.files) {
            const allowedExtensions = [
                'jpg',
                'jpeg',
                'png',
                'doc',
                'docx',
                'ppt',
                'pptx',
                'pdf'
            ];
            const allowedMimeTypes = [
                'image/jpeg',
                'image/png',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/vnd.ms-powerpoint',
                'application/pdf'
            ];

            const maxFileSize = 2 * 1024 * 1024;

            const fileExtension = file.name.split('.').pop();
            const fileMimeType = file.type;
            const fileSize = file.size;

            if (fileSize > maxFileSize) {
                alert("Max file size is 2 MB");
                return;
            }

            if (!allowedExtensions.includes(fileExtension) || !allowedMimeTypes.includes(fileMimeType)) {
                alert("Incorrect file format");
                return;
            }

            previewImage({
                file,
                cb: (preview) => {
                    files.push({ preview, file });
                    if (files.length === event.target.files.length) {
                        this.setState({
                            selectedFiles: this.state.selectedFiles.concat(files),
                            requiredError: this.getNewRequiredErrorState(files)
                        });
                    }
                }
            });
        }
    };

    removeFile = (index) => {
        const files = this.state.selectedFiles;
        files.splice(index, 1);
        this.setState({
            selectedFiles: files,
            requiredError: this.getNewRequiredErrorState(files)
        });
    };

    getNewRequiredErrorState = (files) => {
        return this.state.required ? !files.length : false;
    }

    render() {
        const { textColor } = this.props;
        return (
            <>
                <AppInputWrapper
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    <>
                        <label className="file-picker-label">
                            <button
                                style={{ border: `1px solid ${textColor}`, color: textColor }}
                                type="button"
                                className="upload-files-button"
                            >
                                <span>Select/Upload files</span>
                                <i className="fa fa-upload" aria-hidden="true" color={textColor}/>
                            </button>
                            <input
                                multiple={this.state.multiple === 'Yes'}
                                className="file-picker-input"
                                title=""
                                type="file"
                                onChange={this.handlePickerChange}
                            />
                        </label>
                        <span className="file-restrictions-text">Max file size is 2 MB</span>

                        <div className="file-previews-container">
                            {
                                this.state.selectedFiles.map((el, i) => (
                                    <div className="file-preview-wrapper" key={i}>
                                        {
                                            el.file.type.includes('image') ?
                                                <div
                                                    className="file-preview"
                                                    style={{ backgroundImage: 'url(' + el.preview + ')' }}
                                                /> :
                                                <div className="file-preview file-name">{ el.file.name }</div>
                                        }

                                        <button
                                            onClick={() => this.removeFile(i)}
                                            className="remove-selected-file"
                                        >Delete</button>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="previews-container"/>
                    </>
                </AppInputWrapper>

                {
                    !this.props.isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">

                            <label className="options-select">
                                <select value={this.state.multiple} onChange={this.setMultipleState}>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                                Is multiple
                            </label>

                            <label>
                                <input onChange={this.setLabel} value={this.state.label} type="text"/>
                                label
                            </label>

                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>

                        </div>
                    </AppCollapsible>
                }
            </>
        )
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(FilePicker)